import TokenService from 'config/token.service';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchUser } from 'store/UserSession/features';
import useLanguage from 'utils/hooks/useLanguage';

import './NavMenu.css';
//  import { AllBillsSelector } from 'store/Admin/BillDisplay/reducers';
// import { getBills } from 'store/Admin/BillDisplay/actions';
import { Badge } from '@mui/material';
import {
  BILL_MODIFIED,
  BILL_STATUS_VALIDATION,
  LANGUAGES,
} from 'utils/Constants';

function NavMenu() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { bills } = useSelector((state) => state.allBills);
  const [nbOfToValidate, setNbToValidate] = useState(0);

  useEffect(() => {
    setNbToValidate(
      bills.filter((bill) =>
        [BILL_STATUS_VALIDATION, BILL_MODIFIED].includes(bill.status)
      ).length
    );
  }, [bills]);

  const { language, changeLanguage } = useLanguage();

  const [expanded, setExpanded] = useState(false);
  const [currentPage, setCurrentPage] = useState(window.location.pathname);
  // const [currentLanguage, setCurrentLanguage] = useState(
  //   localStorage.getItem("language")
  // )

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPage(window.location.pathname);
    };
    window.addEventListener('locationchange', handleLocationChange);

    return () => {
      window.removeEventListener('locationchange', handleLocationChange);
    };
  }, []);

  const handleChangeLanguage = (language) => {
    changeLanguage(language);
  };

  return (
    <div>
      <header className="border-bottom fixed-top header-fix bg-light-wh bg-img">
        <div
          className="container-fluid d-grid gap-3 align-items-center"
          style={{ gridTemplateColumns: '1fr 2fr' }}
        >
          <div className="dropdown">
            <button
              className="d-flex align-items-center col-lg-4 mb-lg-0 link-dark text-decoration-none border-0"
              id="dropdownLink"
              aria-expanded="false"
            ></button>
          </div>
          <div className="d-flex align-items-center">
            <form className="box-menu-list w-100 text-end">
              <Link to="/Admin/AjouterClient">
                <div className="btn-menu-icon">
                  <div
                    className={`${
                      currentPage === '/Admin/AjouterClient'
                        ? 'btn-menu-list active'
                        : 'btn-menu-list'
                    }`}
                  >
                    <span>{t('Ajouter un client')}</span>
                  </div>
                </div>
              </Link>

              <Link to="/Admin/NouvelleCommande">
                <div className="btn-menu-icon">
                  <div
                    className={`${
                      currentPage === '/Admin/NouvelleCommande'
                        ? 'btn-menu-list active'
                        : 'btn-menu-list'
                    }`}
                  >
                    <span>{t('Nouvelle commande')}</span>
                  </div>
                </div>
              </Link>

              <Link className="btn-menu-icon" tag={Link} to="/Admin/Redacteur">
                <div
                  className={`box-icon-menu ${
                    currentPage === '/Admin/R%C3%A9dacteur'
                      ? ' bt-icon-redac active'
                      : ' bt-icon-redac'
                  }`}
                ></div>
              </Link>

              <Link
                className="btn-menu-icon"
                tag={Link}
                to="/Admin/GestionUtilisateur"
              >
                <div
                  className={` ${
                    currentPage === '/Admin/GestionUtilisateur'
                      ? 'box-icon-menu bt-icon-util active'
                      : 'box-icon-menu bt-icon-util'
                  }`}
                ></div>
              </Link>

              <div className="btn-menu-icon">
                <div
                  className={`${
                    currentPage === '/Admin/MonProfil'
                      ? 'box-icon-menu bt-icon-user active'
                      : 'box-icon-menu bt-icon-user'
                  }`}
                  id="dropdownMenu2"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />
                <ul
                  className="dropdown-menu menu-list menu-list-sm"
                  aria-labelledby="dropdownMenu2"
                >
                  <li className="first-child">
                    <Link to="/Admin/MonProfil">
                      <button className="dropdown-item" type="button">
                        {t('Mon profil')}
                      </button>
                    </Link>
                  </li>
                  <li className="last-child">
                    <button
                      onClick={() => {
                        TokenService.removeUser();
                        dispatch(fetchUser(null));
                      }}
                      className="dropdown-item"
                      type="button"
                    >
                      {t('Déconnexion')}
                    </button>
                  </li>
                </ul>
              </div>
              <div className="btn-menu-icon">
                <div
                  className="box-icon-menu dropdown-toggle d-flex flex-row align-items-center"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>
                    <div className="flag-img-container-country">
                      <img
                        src={
                          LANGUAGES.find(({ isoCode }) => isoCode === language)
                            ?.img
                        }
                        alt="langage icon"
                      />
                    </div>
                  </span>
                </div>
                <ul
                  className="dropdown-menu menu-list-nav menu-list-lng"
                  aria-labelledby="dropdownMenu2"
                >
                  {LANGUAGES.map(({ isoCode, img }, index) => (
                    <li
                      key={index}
                      onClick={() => handleChangeLanguage(isoCode)}
                    >
                      <button
                        className="dropdown-item d-flex justify-content-center"
                        type="button"
                      >
                        <div className="flag-img-container">
                          <img src={img} alt="language icon" />
                        </div>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </form>
          </div>
        </div>
      </header>
      <div className="box-menu-left">
        <div className={`box-radius-3 ${expanded ? 'expand' : ''}`} />
        <div className="box-radius  bg-img-1">
          <Link tag={Link} to="/Admin/AdminMainMenu">
            <img
              className="logo-m"
              src="Images/logo-typix.png"
              alt="logo-typix"
            />
          </Link>
        </div>
        <div className={`box-radius-2 ${expanded ? 'active' : ''}`} />
        <div
          className="wrapper-box-menu-left"
          onMouseEnter={() => setExpanded(true)}
          onMouseLeave={() => setExpanded(false)}
        >
          <Link tag={Link} to="/Admin/AdminMainMenu">
            <div
              className={`${
                currentPage === '/Admin/AdminMainMenu'
                  ? 'box-menu-block-admin bt-icon-dashboard active'
                  : 'box-menu-block-admin bt-icon-dashboard'
              }`}
            ></div>
          </Link>

          <Link tag={Link} to="/Admin/CommandesNonAttribuees">
            <div
              className={`${
                currentPage === '/Admin/CommandesNonAttribuees'
                  ? 'box-menu-block-admin  bt-icon-non-attr active'
                  : 'box-menu-block-admin  bt-icon-non-attr'
              }`}
            ></div>
          </Link>

          <Link tag={Link} to="/Admin/CommandesEnCours">
            <div
              className={`${
                currentPage === '/Admin/CommandesEnCours'
                  ? 'box-menu-block-admin bt-icon-encour active'
                  : 'box-menu-block-admin bt-icon-encour'
              }`}
            ></div>
          </Link>

          <Link tag={Link} to="/Admin/CommandesEnRetard">
            <div
              className={`${
                currentPage === '/Admin/CommandesEnRetard'
                  ? 'box-menu-block-admin  bt-icon-enretard active'
                  : 'box-menu-block-admin  bt-icon-enretard'
              }`}
            ></div>
          </Link>

          <Link tag={Link} to="/Admin/CommandesValides">
            <div
              className={`${
                currentPage === '/Admin/CommandesValides'
                  ? 'box-menu-block-admin bt-icon-validee active'
                  : 'box-menu-block-admin bt-icon-validee'
              }`}
            ></div>
          </Link>

          <Link tag={Link} to="/Admin/CommandesReview">
            <div
              className={`${
                currentPage === '/Admin/CommandesReview'
                  ? 'box-menu-block-admin bt-icon-smart-with-review-orders active'
                  : 'box-menu-block-admin bt-icon-smart-with-review-orders'
              }`}
            ></div>
          </Link>

          <Link tag={Link} to="/Admin/CommandesIntelligentes">
            <div
              className={`${
                currentPage === '/Admin/CommandesIntelligentes'
                  ? 'box-menu-block-admin bt-icon-smart-orders active'
                  : 'box-menu-block-admin bt-icon-smart-orders'
              }`}
            ></div>
          </Link>

          <div
            className={`box-sub-menu ${expanded ? 'active' : ''}`}
            id="sidebar"
          >
            <div className="box-subtext-menu-admin">
              <div className="box-text-menu-admin">Dashboard</div>
              <div className="box-text-menu-admin">{t('Non attribuées')}</div>
              <div className="box-text-menu-admin">{t('En cours')}</div>
              <div className="box-text-menu-admin">{t('En retard')}</div>
              <div className="box-text-menu-admin">{t('Validées')}</div>
              <div className="box-text-menu-admin">{t('Smart + review')}</div>
              <div className="box-text-menu-admin">{t('Smart')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavMenu;
